import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { and, PrivateRoute, Roles } from '@/js/libs/use-auth';

import SelfBooking from 'src/scenes/SelfBooking';
import { campaignCreateFormRouterSearchParamsSchema } from 'src/scenes/SelfBooking/pages/Campaigns/containers/CampaignCreateForm/types';
import { campaignsListRouterSearchParamsSchema } from 'src/scenes/SelfBooking/pages/Campaigns/containers/CampaignsList/types';
import Status from 'src/scenes/Status';

const index = true;

export const selfBookingRouteObject = inferRouteObject({
  path: 'self-booking',
  element: <PrivateRoute roles={and(Roles.ADMIN, Roles.YALEO_SELF_BOOKING)} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: SelfBooking.Helmet,
      children: [
        { index, element: <Navigate to='./campaigns' replace /> },
        {
          path: 'campaigns',
          searchParams: campaignsListRouterSearchParamsSchema.parse,
          children: [
            { index, Component: SelfBooking.Campaigns.CampaignsList },
            {
              path: 'create',
              Component: SelfBooking.Campaigns.CampaignCreateForm,
              searchParams: campaignCreateFormRouterSearchParamsSchema.parse,
            },
            {
              path: ':campaignId',
              children: [
                { index, Component: SelfBooking.Campaigns.CampaignOverview },
                {
                  path: 'position',
                  children: [
                    { index, element: <Navigate to='./create' replace /> },
                    {
                      path: 'create',
                      Component: SelfBooking.Campaigns.PositionCreateForm,
                    },
                    {
                      path: 'edit',
                      children: [
                        { index, element: <Navigate to='../create' replace /> },
                        { path: ':positionId', Component: SelfBooking.Campaigns.PositionEditForm },
                      ],
                    },
                    {
                      path: 'history',
                      children: [
                        { index, element: <Navigate to='../' replace /> },
                        { path: ':positionId', Component: SelfBooking.Campaigns.PositionHistory },
                      ],
                    },
                  ],
                },
                {
                  path: 'summary',
                  Component: SelfBooking.Campaigns.CampaignSummary,
                },
                {
                  path: 'campaign-history',
                  Component: SelfBooking.Campaigns.CampaignHistory,
                },
                {
                  path: 'order-preview',
                  Component: SelfBooking.Campaigns.OrderPreview,
                },
              ],
            },
          ],
        },
        {
          path: 'advertisers',
          children: [
            { index, Component: SelfBooking.Advertisers.AdvertisersList },
            {
              path: ':advertiserId',
              children: [
                { index, Component: SelfBooking.Advertisers.AdvertiserOverview },
                {
                  path: 'conversion-tracker',
                  children: [
                    { index, element: <Navigate to='./create' replace /> },
                    { path: 'create', Component: SelfBooking.Advertisers.ConversionTrackerForm },
                    {
                      path: 'edit',
                      children: [
                        { index, element: <Navigate to='../create' replace /> },
                        { path: ':conversionTrackerId', Component: SelfBooking.Advertisers.ConversionTrackerForm },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: 'creatives',
          children: [
            { index, Component: SelfBooking.Creatives.CreativesList },
            { path: 'create', Component: SelfBooking.Creatives.CreativeForm },
            {
              path: 'edit',
              children: [
                { index, element: <Navigate to='../' replace /> },
                { path: ':creativeId', Component: SelfBooking.Creatives.CreativeForm },
              ],
            },
          ],
        },
        {
          path: 'creatives-approval',
          children: [{ index, Component: SelfBooking.CreativesApproval.CreativesApprovalList }],
        },
        {
          path: 'screenshot-management',
          children: [{ index, Component: SelfBooking.ScreenshotManagement.ScreenshotManagementList }],
        },
        {
          path: 'invoicing',
          children: [{ index, Component: SelfBooking.Invoicing.InvoicingList }],
        },
        {
          path: 'receipts',
          Component: SelfBooking.Receipts.Layout,
          children: [
            { index, element: <Navigate to='./payments' replace /> },
            {
              path: 'payments',
              Component: SelfBooking.Receipts.Payments,
            },
            {
              path: 'payouts',
              element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
              children: [{ index, Component: SelfBooking.Receipts.Payouts }],
            },
          ],
        },
        {
          path: 'billing',
          Component: SelfBooking.Billing.Layout,
          children: [
            { index, element: <Navigate to='./transactions-history' replace /> },
            {
              path: 'transactions-history',
              Component: SelfBooking.Billing.TransactionsHistory,
            },
            {
              path: 'payment-methods',
              Component: SelfBooking.Billing.PaymentMethods,
            },
          ],
        },
      ],
    },
  ],
});
